import { ApiResponseType } from './api';

export enum InviteStatusEnum {
    invited,
    joined,
    deleted,
}

// export enum CandidateInviteStatusEnum {
//     joined,
//     uploaded,
//     pending,
//     deleted,
//     invited,
// }

export enum CompanyLeadStatus {
    Uploaded,
    InviteSent,
    RequestToOnboard,
    Approved,
    Rejected,
    Onboard,
}

export type CompanyLeadResendParamType = {
    companyLeadId: string;
};

// export type CreateInviteRequestType = {
//     firstName: string;
//     middleName: string;
//     lastName: string;
//     email: string;
//     emailSubject: string;
//     emailMessage: string;
// };

export type CreateInviteRequestType = {
    firstName: string;
    middleName: string;
    lastName: string;
    userEmail: string;
    companyName: string;
    companyWebsite: string;
    companyEmail: string;
    companyContact: string;
    companyCountryCode: string;
    companyCityCode: string;
    companyStateCode: string;
    postalCode: string;
    companySTDCode: string;
    ownerSTDCode: string;
    contactNumber: string;
    companyCountryName?: string;
    companyStateName?: string;
    companyCityName?: string;
};

export type InviteType = {
    id: string;
    active: boolean;
    email: string;
    firstName: string;
    lastName: string;
    middleName: string;
    inviteStatus: InviteStatusEnum;
    invitedDate: Date;
};

export type CandidateInviteListType = {
    candidateId?: string;
    // candidateStatus: CandidateInviteStatusEnum;
    email: string;
    firstName: string;
    invitationId?: string;
    invitedDate: Date;
    isInvited?: boolean;
    lastName: string;
    phone: string;
};

export type InviteListResponseType = Omit<ApiResponseType, 'resultObject'> & {
    resultObject: {
        items: InviteType[];
        hasMore: boolean;
        count: number;
    };
};

export type CandidateInviteListResponseType = Omit<ApiResponseType, 'resultObject'> & {
    resultObject: {
        items: CandidateInviteListType[];
        hasMore: boolean;
        count: number;
    };
};

export type CompanyLeadResendType = Omit<ApiResponseType, 'resultObject'> & {
    isSuccessful: boolean;
    resultObject: {
        isEmailSent: boolean;
        errorMessage: string;
    };
};

export type ScreenXCompanyLeadResendType = Omit<ApiResponseType, 'result'> & {
    statusCode: number;
    result: {
        isEmailSent: boolean;
        errorMessage: string;
    };
};

export const filterValueText = (col: any) => {
    const resultData = JSON.parse(sessionStorage.getItem(col.dataIndex)!);

    if (resultData) {
        switch (col.dataIndex) {
            case 'name':

            case 'fullName':

            case 'registeredBy':

            case 'jobTitle':

            case 'documentType':

            case 'createdDate':

            case 'onboardedDate':

            case 'dateInvited':

            case 'salesOwner':

            case 'salesOwnerName':

            case 'contactNumber':

            case 'inviteStatus':

            case 'inviteType':

            case 'ownerPhoneNumber':

            case 'suspendStatus':

            case 'uploadedDate':

            case 'companyName':

            case 'location':

            case 'leadStatus':

            case 'companyInviteType':

            case 'website':

            case 'companySuspendReasonText':

            case 'suspensionDecision':

            case 'rating':

            case 'candidateState':

            case 'reportedByCompanyName':

            case 'candidateSuspendReasonText':

            case 'candidateFullName':

            case 'reportedDate':

            case 'email':

            case 'role':

            case 'dateAdded':

            case 'joinStatus':

            case 'phone':

            case 'documentUploadedDate':

            case 'salesOwnerOfferx':

            case 'companyWebsite':

            case 'adminPhone':

            case 'companyPhone':

            case 'adminName':

            case 'registrationDate':

            case 'adminEmail':

            case 'companyEmail':

            case 'hrmsJoinStatus':

            case 'firstName':

            case 'lastName':

            case 'phoneNumber':

            case 'referralCode':

            case 'referralURL':

            case 'affiliatedBy':

            case 'companiesRegistered':

            case 'ownerEmail':

            case 'invitedDate':

            case 'candidateStatus':

            case 'dataPunchStatus':

            case 'serviceType':

            case 'date':

            case 'doneBy':

            case 'points':

            case 'totalPoints':

            case 'isLatestDocumentEsigned':

            case 'companyAvailableCredits':
            case 'candidateName':
            case 'matchDetails':
            case 'dataPunchDate':
            case 'punchedByCompany':
            case 'countryNames':
            case 'uploadedBy':
            case 'reportedBy':
            case 'offerType':
            case 'reviewType':
            case 'currentStatus':
            case 'reportedOnCompanyName':
            case 'reportStatus':
            case 'reportedDateFilter':
                return resultData;

            default:
                return '';
        }
    } else {
        return '';
    }
};
